// import addReportQt from '../components/reportQt/addReportQt.vue'
// import reportQtList from '../components/reportQt/reportQtList.vue'
// import viewReportQt from '../components/reportQt/viewReportQt.vue'

export default [
    { 
        path: 'reportQt/addReportQt', 
        component: resolve => require(['@/components/reportQt/addReportQt'],resolve),
        name:'AddReportQt',
        meta:{
            // id:'831',
            node:'reportQt',
            url:'addReportQt',
        }
    },
    { 
        path: 'reportQt/reportQtList', 
        component: resolve => require(['@/components/reportQt/reportQtList'],resolve),
        name:'ReportQtList',
        meta:{
            // id:'831',
            node:'reportQt',
            url:'reportQtList',
        }
    },
    { 
        path: 'reportQt/viewReportQt', 
        component: resolve => require(['@/components/reportQt/viewReportQt'],resolve),
        name:'ViewReportQt',
        meta:{
            // id:'831',
            node:'reportQt',
            url:'viewReportQt',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/reportQt.js